import { Component, HostBinding, Input } from '@angular/core';
import { CmsComponentData } from "@spartacus/storefront";
import { tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { CustomItemAccordionData } from "./custom-item-accordion.model";
import { ICON_TYPE } from "../../../../icons/icon.model";
import { panelInOut } from "../../../../animation/custom-animations";

@Component({
  selector: 'app-custom-item-accordion',
  templateUrl: './custom-item-accordion.component.html',
  styleUrls: ['./custom-item-accordion.component.scss'],
  animations: [panelInOut],
  standalone: false
})
export class CustomItemAccordionComponent {

  @Input() item: CustomItemAccordionData;
  @HostBinding('class') styleClasses: string;

  iconTypes = ICON_TYPE;
  showContent = false;

  data$: Observable<CustomItemAccordionData> = this.component.data$.pipe(
    tap((data) => (this.styleClasses = data?.styleClasses))
  );

  constructor(public component: CmsComponentData<CustomItemAccordionData>) {}

  showContents(): void {
    this.showContent = !this.showContent;
  }
}
